import { TokenSelectItem } from '@/app/components/Modal/TokenRow';
import { TokenSelectList } from '@/app/components/Modal/TokenSelectList';
import { cn } from '@/app/shared/lib/cn';

type TokenSelectDropdownProps = {
  tokens: TokenSelectItem[];
  selectedToken?: string;
  onSelect: (token: TokenSelectItem) => void;
  className?: string;
};

export const TokenSelectDropdown = ({
  tokens,
  selectedToken,
  onSelect,
  className,
}: TokenSelectDropdownProps) => (
  <div
    className={cn(
      'absolute top-full right-0 left-0 z-20 mt-1 overflow-hidden rounded-md border border-gray-700 bg-elevated-card-2 p-4 shadow-[var(--shadow-elevated)] [:root.light_&]:border-gray-900',
      className,
    )}
  >
    <TokenSelectList tokens={tokens} selectedToken={selectedToken} onSelect={onSelect} />
  </div>
);
